<div [style.display]="agentStatus.isEnabled() ? 'contents' : 'none'">
  <button
    class="btn p-1 lh-1 border-0 position-relative"
    [disabled]="agentStatus.isStatusChangeInProgress()"
    (click)="statusPanel.toggle($event)"
    [pTooltip]="statusTooltip()"
    tooltipPosition="left">
    <i
      class="fas fa-headset lpx-menu-item-icon agent-status-icon"
      [ngClass]="agentStatus.statusColorClass()"
      [class.agent-status-icon-spinning]="agentStatus.isStatusChangeInProgress()"></i>
    <span class="agent-status-dot" [ngClass]="agentStatus.statusDotClass()"></span>
  </button>

  <p-popover #statusPanel styleClass="agent-status-popover" appendTo="body">
    <app-agent-status-dropdown
      [currentStateId]="agentStatus.currentStateId()"
      [queuedNextStateId]="agentStatus.queuedNextStateId()"
      [isOnCallOrAcw]="agentStatus.isOnCall() || agentStatus.isAcw()"
      (statusSelected)="onStatusSelected($event)"
      (queuedStatusCleared)="onQueuedCleared()"
      (closed)="statusPanel.hide()" />
  </p-popover>
</div>

<app-incoming-call-toast
  [ringtoneMuted]="ringtoneMuted()"
  [toastAnswering]="answering()"
  [callerDetail]="callerDetail()"
  [queueName]="queueName()"
  (answer)="onAnswer()"
  (reject)="onReject()"
  (muteToggle)="onMuteToggle()"
/>
